import React from 'react';
import { StyleSheet } from 'react-native';

import { theme } from '@garnish/constants';
import { IllusEmpty_2 } from '@garnish/core';
import { useResponsive } from '@garnish/core';
import { FallbackImage, PRODUCT_THUMBNAIL_IMAGE_CONFIG } from '@garnish/media';

// ────────────────────────────────────────────────────────────────────────────────

export const LineItemThumbnail = (props: LineItemThumbnailProps) => {
  const { cloudinaryImageUrl } = props;
  const { match } = useResponsive();

  return (
    <FallbackImage
      baseUrl={cloudinaryImageUrl}
      defaultImage={IllusEmpty_2}
      contentFit="contain"
      style={match([styles.imageXs, styles.imageSm])}
      cloudinaryConfig={PRODUCT_THUMBNAIL_IMAGE_CONFIG}
    />
  );
};

// ─── Constants ──────────────────────────────────────────────────────────────────

export const THUMBNAIL_SIZE_XS = 80;
export const THUMBNAIL_SIZE_SM = 120;

// ─── Styles ─────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  imageXs: {
    marginTop: theme.spacing['1'],
    width: 80,
    height: 80,
  },
  imageSm: {
    marginTop: theme.spacing['1'],
    width: 120,
    height: 120,
  },
});

// ─── Types ──────────────────────────────────────────────────────────────────────

type LineItemThumbnailProps = Readonly<{
  cloudinaryImageUrl: string;
}>;
